import {
    UpdateWordTranslationInput,
    WordTranslationObject
} from "../../../types.d";

export const translationObjectToInput = (object: WordTranslationObject): UpdateWordTranslationInput => {
    return {
        translation: object.translationWord?.id,
        sourceWord: object.sourceWord?.id,
        audio: object.audio,
        separateMeanings: object.separateMeanings,
        sourceLanguage: object.sourceLanguage.id,
        translationLanguage: object.translationLanguage.id,
    };
};
